import { react, useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Image from 'mui-image';
import TokenService from '../../services/TokenService'
import Button from '@mui/material/Button';

import LoadingButton from '@mui/lab/LoadingButton';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import GaugeChart from 'react-gauge-chart'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import LinearProgress from '@mui/material/LinearProgress';
import AvailableDateAndCustomerType from './AvailableDateAndCustomerType'
import ContactlessPickup from './ContactlessPickup';
import CountOrEstimator from './CountOrEstimator';
import BusinessHours from './BusinessHours';
import QuantityPanel from './QuantityPanel';
import EstimateSummary from './EstimateSummary';
import PaymentOptions from './PaymentOptions';
import CustomerInformation from './CustomerInformation';
import SpecialInstructions from './SpecialInstructions';
import StoreSelection from './StoreSelection';
import Summary from './Summary';
import Confirmation from './Confirmation';
import ExistingPickup from './ExistingPickup';
import ClearIcon from '@mui/icons-material/Clear';
import ScrollMore from '../ScrollMore'
import dayjs from 'dayjs';


const PickupWizard = (props) => {
    
    const ref = useRef(true);
    const [isShown, setisShown] = useState(props.isShown);
    const [numberOfSteps, setNumberOfSteps] = useState(9);
    const [stepNumber, setStepNumber] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [existingPickup, setExistingPickup] = useState(null);


    const [activeStep, setActiveStep] = useState('');
    let defaultPickup = {
        CustomerDateAvailableForPickup: undefined,
        CustomerType: undefined,
        isContactless: undefined,
        Quantifier: undefined
    };

   // const [pickupRequest, setPickupRequest] = useState(defaultPickup);
    let _pickupRequest = useRef({});

    useEffect(() => {
        const firstRender = ref.current;

        if (firstRender) {
            ref.current = false;
           // console.log('First Render');

            if (props.fromExisting !== undefined) {
                // setup existing pickup data
                // step to the Summary?
                setStepNumber(9);
                setActiveStep('Summary');
            }
            else {

              
                stepForward();
            }
            
        } else {
           // console.log('Not a first Render');
           
        }
    });

    if (props.isShown) {
        return buildWizard();
    } else {
        return null;
    }

    function stepForward() {

      

        if (activeStep == '') {
            setStepNumber(1);
            setActiveStep('Select Date and Type');
        }
        else if (activeStep == 'Select Date and Type') {
            if (_pickupRequest.CustomerType === 'Residence') {
                //setStepNumber(2);
                //setActiveStep('Acknowledge Contactless Pickup');

                setStepNumber(2);
                setActiveStep('Count or Estimator');
            }
            else {
                setStepNumber(2);
                setActiveStep('Business Hours');
            }
        }
        //else if (activeStep == 'Acknowledge Contactless Pickup' || activeStep == 'Business Hours') {
        //    setStepNumber(3);
        //    setActiveStep('Count or Estimator');
        //}
        else if (activeStep == 'Business Hours') {
            setStepNumber(3);
            setActiveStep('Count or Estimator');
        }
        else if (activeStep == 'Count or Estimator') {
            if (_pickupRequest.Quantifier == 'Estimate') {
                setStepNumber(4);
                setActiveStep('Estimator');
            }
            else {
                setStepNumber(4);
                setActiveStep('Exact Count');
            }
        }
        else if (activeStep == 'Estimator') {
            setStepNumber(4);
            setActiveStep('Exact Count');
        }
        else if (activeStep == 'Exact Count' || activeStep == 'Estimator') {
            setStepNumber(5);
            setActiveStep('Payment Options');
        }
        else if (activeStep == 'Payment Options') {
            setStepNumber(6);
            setActiveStep('Customer Information');
        }
        else if (activeStep == 'Customer Information') {
            setStepNumber(7);
            setActiveStep('Special Instructions');
        }
        else if (activeStep == 'Special Instructions') {
            setStepNumber(8);
            setActiveStep('Store Selection');
        }
        else if (activeStep == 'Store Selection') {
            setStepNumber(9);
            setActiveStep('Summary');
        }
        customerPageUpdate(activeStep);
        
    }

    function customerPageUpdate(pageReached) {
        let postData = {
            pickupPageReached: pageReached
        }

        
        TokenService.post(postData, 'CustomerPageUpdate', '')
            .then((response) => {
               
            })
            .catch((response) => {
               
            });
    }

    function stepBack() {
        //if (activeStep == 'Acknowledge Contactless Pickup' || activeStep == 'Business Hours') {
        //    setStepNumber(1);
        //    setActiveStep('Select Date and Type');
        //}
        if (activeStep == 'Business Hours') {
            setStepNumber(1);
            setActiveStep('Select Date and Type');
        }
        else if (activeStep == 'Count or Estimator') {
            if (_pickupRequest.CustomerType === 'Residence') {
                //setStepNumber(2);
                //setActiveStep('Acknowledge Contactless Pickup');
                setStepNumber(1);
                setActiveStep('Select Date and Type');
            }
            else {
                setStepNumber(2);
                setActiveStep('Business Hours');
            }
        }
        else if (activeStep == 'Exact Count' || activeStep == 'Estimator') {
            setStepNumber(3);
            setActiveStep('Count or Estimator');
        }
        else if (activeStep == 'Payment Options') {
            if (_pickupRequest.Quantifier == 'Estimate') {
                setStepNumber(4);
                setActiveStep('Estimator');
            }
            else {
                setStepNumber(4);
                setActiveStep('Exact Count');
            }
        }
        else if (activeStep == 'Customer Information') {
            setStepNumber(5);
            setActiveStep('Payment Options');
        }
        else if (activeStep == 'Special Instructions') {
            setStepNumber(6);
            setActiveStep('Customer Information');
        }
        else if (activeStep == 'Store Selection') {
            setStepNumber(7);
            setActiveStep('Special Instructions');
        }
        else if (activeStep == 'Summary') {
            setStepNumber(8);
            setActiveStep('Store Selection');
        }
        customerPageUpdate(activeStep);
    }

    function AvailableDateAndCustomerType_OnAccepted(date, type) {
        
        _pickupRequest.CustomerDateAvailableForPickup = date;
        _pickupRequest.CustomerType = type;
        
        stepForward();
    }

    function ContactlessPickup_OnAccepted(isContactless) {
        _pickupRequest.isContactless = isContactless;
        stepForward();
    }

    function CountOrEstimator_OnAccepted(quantifier) {
        _pickupRequest.Quantifier = quantifier;
        stepForward();
    }

    function BusinessHours_OnAccepted(hasMondayHours, mondayHoursStart, mondayHoursEnd,
        hasTuesdayHours, tuesdayHoursStart, tuesdayHoursEnd,
        hasWednesdayHours, wednesdayHoursStart, wednesdayHoursEnd,
        hasThursdayHours, thursdayHoursStart, thursdayHoursEnd,
        hasFridayHours, fridayHoursStart, fridayHoursEnd,
        hasSaturdayHours, saturdayHoursStart, saturdayHoursEnd,
        hasSundayHours, sundayHoursStart, sundayHoursEnd)
    {
        _pickupRequest.hasMondayHours = hasMondayHours;
        if (hasMondayHours) {
            _pickupRequest.mondayHoursStart = mondayHoursStart;
            _pickupRequest.mondayHoursEnd = mondayHoursEnd;
        }
        else {
            _pickupRequest.mondayHoursStart = undefined;
            _pickupRequest.mondayHoursEnd = undefined;
        }

        _pickupRequest.hasTuesdayHours = hasTuesdayHours;
        if (hasTuesdayHours) {
            _pickupRequest.tuesdayHoursStart = tuesdayHoursStart;
            _pickupRequest.tuesdayHoursEnd = tuesdayHoursEnd;
        }
        else {
            _pickupRequest.tuesdayHoursStart = undefined;
            _pickupRequest.tuesdayHoursEnd = undefined;
        }

        _pickupRequest.hasWednesdayHours = hasWednesdayHours;
        if (hasWednesdayHours) {
            _pickupRequest.wednesdayHoursStart = wednesdayHoursStart;
            _pickupRequest.wednesdayHoursEnd = wednesdayHoursEnd;
        }
        else {
            _pickupRequest.wednesdayHoursStart = undefined;
            _pickupRequest.wednesdayHoursEnd = undefined;
        }

        _pickupRequest.hasThursdayHours = hasThursdayHours;
        if (hasThursdayHours) {
            _pickupRequest.thursdayHoursStart = thursdayHoursStart;
            _pickupRequest.thursdayHoursEnd = thursdayHoursEnd;
        }
        else {
            _pickupRequest.thursdayHoursStart = undefined;
            _pickupRequest.thursdayHoursEnd = undefined;
        }

        _pickupRequest.hasFridayHours = hasFridayHours;
        if (hasFridayHours) {
            _pickupRequest.fridayHoursStart = fridayHoursStart;
            _pickupRequest.fridayHoursEnd = fridayHoursEnd;
        }
        else {
            _pickupRequest.fridayHoursStart = undefined;
            _pickupRequest.fridayHoursEnd = undefined;
        }

        _pickupRequest.hasSaturdayHours = hasSaturdayHours;
        if (hasSaturdayHours) {
            _pickupRequest.saturdayHoursStart = saturdayHoursStart;
            _pickupRequest.saturdayHoursEnd = saturdayHoursEnd;
        }
        else {
            _pickupRequest.saturdayHoursStart = undefined;
            _pickupRequest.saturdayHoursEnd = undefined;
        }

        _pickupRequest.hasSundayHours = hasSundayHours;
        if (hasSundayHours) {
            _pickupRequest.sundayHoursStart = sundayHoursStart;
            _pickupRequest.sundayHoursEnd = sundayHoursEnd;
        }
        else {
            _pickupRequest.sundayHoursStart = undefined;
            _pickupRequest.sundayHoursEnd = undefined;
        }

        stepForward();
    }

    function ExactCount_OnAccepted(quantity, photos) {
        _pickupRequest.Quantity = quantity;
        _pickupRequest.Photos = photos;

        stepForward();
    }

    function Estimator_OnAccepted(containers, quantity) {
       // console.log('estimator accepted');
        _pickupRequest.Containers = containers;
        _pickupRequest.Quantity = quantity;

        stepForward();
    }

    function PaymentOption_OnAccepted(paymentType, selectedDonation) {
       // console.log('Payment Option Accepted');
        _pickupRequest.CustomerPaymentMethod = paymentType;
        _pickupRequest.Donation = selectedDonation;

        stepForward();
    }

    function CustomerInformation_OnAccepted(firstName, lastName, checkPayee, emailAddress, phoneNumber, receiveSMSUpdates, street1, street2, city, state, zip, latitude, longitude) {
        _pickupRequest.CustomerName = firstName;
        _pickupRequest.CustomerLastname = lastName;
        _pickupRequest.CustomerCheckPayeeName = checkPayee;
        _pickupRequest.CustomerEmail = emailAddress;
        _pickupRequest.CustomerPhoneNum = phoneNumber;
        _pickupRequest.CustomerWantsTextMsg = receiveSMSUpdates;
        _pickupRequest.CustomerAddress_Street = street1;
        _pickupRequest.CustomerAddress_Apt_Suit_Other = street2;
        _pickupRequest.CustomerAddress_City = city;
        _pickupRequest.CustomerAddress_State = state;
        _pickupRequest.CustomerAddress_Zipcode = zip;
        _pickupRequest.Latitude = latitude;
        _pickupRequest.Longitude = longitude;

        stepForward();
    }

    function SpecialInstructions_OnAccepted(specialInstructions) {
        _pickupRequest.CustomerSpecialInstructions = specialInstructions;
        stepForward();
    }

    function StoreSelection_OnAccepted(selectedStores, otherStore) {
        
        _pickupRequest.SelectedStores = selectedStores;
        _pickupRequest.OtherStore = otherStore;
        stepForward();
    }

    function Summary_OnAccepted(recyclerTip, requestedRecycler) {
        _pickupRequest.TipAmount = recyclerTip;
      
        let formattedPickup = {};

        // format the structure to match the service
        formattedPickup.RequestedRecycler = requestedRecycler;
        formattedPickup.CustomerEmail = _pickupRequest.CustomerEmail;
        formattedPickup.CustomerName = _pickupRequest.CustomerName;
        formattedPickup.CustomerLastname = _pickupRequest.CustomerLastname;
        formattedPickup.CustomerWantsTextMsg = _pickupRequest.CustomerWantsTextMsg.toString();
        formattedPickup.TipAmount = _pickupRequest.TipAmount;

        // Not yet implemented
        //formattedPickup.QuickAccessTag = _pickupRequest.QuickAccessTag;
                    

        formattedPickup.CustomerCheckPayeeName = _pickupRequest.CustomerCheckPayeeName;
        formattedPickup.CustomerPhoneNum = _pickupRequest.CustomerPhoneNum;
        formattedPickup.CustomerAddress_Street = _pickupRequest.CustomerAddress_Street;
        formattedPickup.CustomerAddress_Apt_Suit_Other = _pickupRequest.CustomerAddress_Apt_Suit_Other;
        formattedPickup.CustomerAddress_City = _pickupRequest.CustomerAddress_City;
        formattedPickup.CustomerAddress_State = _pickupRequest.CustomerAddress_State;
        formattedPickup.CustomerAddress_Zipcode = _pickupRequest.CustomerAddress_Zipcode;
        formattedPickup.Quantity_Of_Cans_Bottles = _pickupRequest.Quantity;
        formattedPickup.BottleValue = ''; // set on the server
        formattedPickup.Returnable_Type_Container_Detail_JSON = '';

        if (_pickupRequest.Quantifier === 'Estimate' && _pickupRequest.Containers !== undefined) {
            // Estimator tool was used
            let formattedContainers = [];
            
            for (let i = 0; i < _pickupRequest.Containers.length; i++) {
                let containerName = '';
                if (_pickupRequest.Containers[i].containerType === 'Plastic Grocery Bag') {
                    containerName = 'Plastic Grocery';
                }
                else if (_pickupRequest.Containers[i].containerType === 'Paper Grocery Bag') {
                    containerName = 'Paper Grocery';
                }
                else if (_pickupRequest.Containers[i].containerType === 'Garbage Bag') {
                    if (_pickupRequest.Containers[i].containerSize === 'Small') {
                        containerName = 'Sml Garbage';
                    }
                    else if (_pickupRequest.Containers[i].containerSize === 'Medium') {
                        containerName = 'Med Garbage Bag'
                    }
                    else if (_pickupRequest.Containers[i].containerSize === 'Large') {
                        containerName = 'Lg Garbage Bag'
                    }
                    else if (_pickupRequest.Containers[i].containerSize === 'XLarge') {
                        containerName = 'XLg Garbage Bag'
                    }
                }
                else if (_pickupRequest.Containers[i].containerType === 'Original Package') {
                    if (_pickupRequest.Containers[i].containerSize === 'otherpack') {
                        containerName = _pickupRequest.Containers[i].customPackQuantity + ' Pack';
                    }
                    else {
                        containerName = _pickupRequest.Containers[i].containerSize;
                    }

                }
                else if (_pickupRequest.Containers[i].containerType === 'Custom Container') {
                    containerName = 'Custom';
                }

                let contents = [];

                if (_pickupRequest.Containers[i].contentsCans) {
                    contents.push('12 Oz Cans')
                }
                if (_pickupRequest.Containers[i].contentsBottles) {
                    contents.push('12 Oz Bottles')
                }
                if (_pickupRequest.Containers[i].contentsLargerCansBottles) {
                    contents.push('Larger Cans & Bottles')
                }
                if (_pickupRequest.Containers[i].contents2Liters) {
                    contents.push('2 Liter Bottles')
                }

              

                formattedContainers.push({
                    Quantity: _pickupRequest.Containers[i].quantity,
                    ContainerName: containerName,
                    Fullness: _pickupRequest.Containers[i].containerFullness.toString() + '%',
                    ReturnableCount: _pickupRequest.Containers[i].returnableCount,
                    Description: contents.length > 0 ? contents.join(', ') : ''

                })
                
            }
            formattedPickup.Returnable_Type_Container_Detail_JSON = formattedContainers;
        }

        if (_pickupRequest.Donation !== undefined && _pickupRequest.CustomerPaymentMethod === 'Donate') {
            formattedPickup.CustomerPaymentMethod = _pickupRequest.Donation.Tag;
        }
        else {
            formattedPickup.CustomerPaymentMethod = _pickupRequest.CustomerPaymentMethod;
        }
        

        formattedPickup.CustomerDateAvailableForPickup = _pickupRequest.CustomerDateAvailableForPickup.format('MM/DD/YYYY');
        formattedPickup.CustomerSpecialInstructions = _pickupRequest.CustomerSpecialInstructions;
        if (_pickupRequest.Photos.length > 0) {
            let formattedPhotos = [];
            for (let i = 0; i < _pickupRequest.Photos.length; i++) {
                formattedPhotos.push({ Value: _pickupRequest.Photos[i].imageData })
            }
            formattedPickup.CustomerPhotoDataBase64String = formattedPhotos;
        }
        else {
            formattedPickup.CustomerPhotoDataBase64String = '';
        }
      
        formattedPickup.SummaryTableHTML = ''; // not used

        formattedPickup.Latitude = _pickupRequest.Latitude;
        formattedPickup.Longitude = _pickupRequest.Longitude;

        // not yet implememented
        //PickUpRequest_Object["ClientId"];


        formattedPickup.LocationType = _pickupRequest.CustomerType;

        if (_pickupRequest.SelectedStores !== undefined) {
            formattedPickup.SelectedStores = _pickupRequest.SelectedStores;
            if (_pickupRequest.OtherStore !== undefined &
                _pickupRequest.OtherStore !== '') {
                formattedPickup.SelectedStores.push(_pickupRequest.OtherStore);
            }
        }
        else if (_pickupRequest.OtherStore !== undefined &&
            _pickupRequest.OtherStore !== '') {
            formattedPickup.SelectedStores = [_pickupRequest.OtherStore];
        }


        if (_pickupRequest.CustomerType == 'Business') {
            formattedPickup.Business_DoW_Selected = new Array();
            formattedPickup.Business_DoW_Hours = new Array();

            formattedPickup.Business_DoW_Selected.push(_pickupRequest.hasMondayHours);
            formattedPickup.Business_DoW_Selected.push(_pickupRequest.hasTuesdayHours);
            formattedPickup.Business_DoW_Selected.push(_pickupRequest.hasWednesdayHours);
            formattedPickup.Business_DoW_Selected.push(_pickupRequest.hasThursdayHours);
            formattedPickup.Business_DoW_Selected.push(_pickupRequest.hasFridayHours);
            formattedPickup.Business_DoW_Selected.push(_pickupRequest.hasSaturdayHours);
            formattedPickup.Business_DoW_Selected.push(_pickupRequest.hasSundayHours);

            formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasMondayHours ? [_pickupRequest.mondayHoursStart.format('HH:mm'), _pickupRequest.mondayHoursEnd.format('HH:mm')] : null);
            formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasTuesdayHours ? [_pickupRequest.tuesdayHoursStart.format('HH:mm'), _pickupRequest.tuesdayHoursEnd.format('HH:mm')] : null);
            formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasWednesdayHours ? [_pickupRequest.wednesdayHoursStart.format('HH:mm'), _pickupRequest.wednesdayHoursEnd.format('HH:mm')] : null);
            formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasThursdayHours ? [_pickupRequest.thursdayHoursStart.format('HH:mm'), _pickupRequest.thursdayHoursEnd.format('HH:mm')] : null);
            formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasFridayHours ? [_pickupRequest.fridayHoursStart.format('HH:mm'), _pickupRequest.fridayHoursEnd.format('HH:mm')] : null);
            formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasSaturdayHours ? [_pickupRequest.saturdayHoursStart.format('HH:mm'), _pickupRequest.saturdayHoursEnd.format('HH:mm')] : null);
            formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasSundayHours ? [_pickupRequest.sundayHoursStart.format('HH:mm'), _pickupRequest.sundayHoursEnd.format('HH:mm')] : null);

           
        }

        let postData = {
            Customer_Request_Data: JSON.stringify(formattedPickup),
            RequestGuid: props.pickupData.RequestGuid == undefined ? '' : props.pickupData.RequestGuid
        }

        setIsLoading(true);
        TokenService.post(postData, 'PostReturnerRequest', '')
            .then((response) => {
                if (response !== null) {
                    setIsLoading(false);
                    response = response[Object.keys(response)[0]];
                    if (response.Result === "SUCCESS") {
                        //let jsonData = JSON.parse(response.JsonData);
                       
                        let data = JSON.parse(response.JsonData);
                        _pickupRequest.RequestId = data.RequestId;
                        _pickupRequest.RequestSalesLead = data.RequestSalesLead;
                        setActiveStep('Confirmation');
                    }
                    else if (response.Message == 'ExistingRequest') {
                        setExistingPickup(JSON.parse(response.JsonData));
                        setActiveStep('Existing Pickup');
                        //showExistingRequestPrompt(existingRequest);
                    }
                    else if (response.Result === "FAIL") {
                        if (response.Message === "Validation Errors") {
                            let errorsList = '';
                            try {
                                let ValidationError = JSON.parse(response.JsonData);
                                //$.each(ValidationError, function (x) {
                                //    errorsList += '<br>' + ValidationError[x];
                                //});
                            }
                            catch (err) {
                                errorsList = '';
                            };
                        }
                        else {
                            // unexpected error
                        }
                    }
                }
            })
            .catch((response) => {
                if (response !== null) {
                    if (response.Result === "FAIL") {
                        
                    }
                    
                }
            });
        
    }

    function closePickupWizard() {
        ref.current = true;
        setNumberOfSteps(8);
        setStepNumber(0);
        setActiveStep('');
        //setPickupRequest(defaultPickup);
        _pickupRequest = {};
        props.onCancel();
    }

    function calculatePayment(quantity) {
        console.log('calculating payment for ' + quantity);

        if (typeof quantity === 'string') {
            // typed into input field
            if (quantity.trim() == '') {
                return '';
            }
            else if (!isNaN(quantity)) {

                // Create a number formatter.
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',

                    // These options are needed to round to whole numbers if that's what you want.
                    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
                });


                return formatter.format(parseInt(quantity) * .1 * parseFloat(props.pickupData.Settings.ClientQuantityPercentage)); /* $2,500.00 */

            }
            else {
                return '';
            }
        }
        else {
            // Create a number formatter.
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',

                // These options are needed to round to whole numbers if that's what you want.
                //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
            });


            return formatter.format(parseInt(quantity) * .1 * parseFloat(props.pickupData.Settings.ClientQuantityPercentage)); /* $2,500.00 */

        }
    }

    function orderMinimumQuantity() {
        return parseInt(props.pickupData.Settings.MinQuantity)
    }

    function orderMaximumQuantity() {
        return parseInt(props.pickupData.Settings.MaxQuantity)
    }

    function buildLoadingPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
            >
                <CircularProgress color="secondary" />
            </Box>
        )

    }

    function setupQuickTagData() {
                // initialized with quick-tag
        _pickupRequest.CustomerName = props.pickupData.Client.CustomerName;
        _pickupRequest.CustomerLastname = props.pickupData.Client.CustomerLastname;
        _pickupRequest.CustomerCheckPayeeName = props.pickupData.Client.PayeeName;
        _pickupRequest.CustomerEmail = props.pickupData.Client.CustomerEmail;
        _pickupRequest.CustomerPhoneNum = props.pickupData.Client.CustomerPhoneNum;
        _pickupRequest.CustomerWantsTextMsg = "true";
        _pickupRequest.CustomerAddress_Street = props.pickupData.Client.CustomerAddress_Street;
        _pickupRequest.CustomerAddress_Apt_Suit_Other = props.pickupData.Client.CustomerAddress_Apt_Suit_Other;
        _pickupRequest.CustomerAddress_City = props.pickupData.Client.CustomerAddress_City;
        _pickupRequest.CustomerAddress_State = props.pickupData.Client.CustomerAddress_State;
        _pickupRequest.CustomerAddress_Zipcode = props.pickupData.Client.CustomerAddress_Zipcode;
        _pickupRequest.Latitude = props.pickupData.Client.Latitude;
        _pickupRequest.Longitude = props.pickupData.Client.Longitude;

        _pickupRequest.Quantifier = 'Estimate';

        if (props.pickupData.QuickAccessTag !== undefined) {
            _pickupRequest.QuickAccessTag = props.pickupData.QuickAccessTag;
        }

        _pickupRequest.CustomerType = props.pickupData.Client.LocationType;
        _pickupRequest.CustomerSpecialInstructions = props.pickupData.SpecialInstructions;

        if (props.pickupData.CustomerCheckPayeeName !== undefined) {
            _pickupRequest.CustomerCheckPayeeName = props.pickupData.CustomerCheckPayeeName;
        }

        if (props.pickupData.CustomerPaymentMethod !== undefined) {
            _pickupRequest.CustomerPaymentMethod = props.pickupData.CustomerPaymentMethod;
        }

        if (_pickupRequest.CustomerType == 'Business') {
            if (props.pickupData.MonHours !== undefined) {
                _pickupRequest.hasMondayHours = props.pickupData.MonHours !== '';
            }

            if (props.pickupData.TueHours !== undefined) {
                _pickupRequest.hasTuesdayHours = props.pickupData.TueHours !== '';
            }

            if (props.pickupData.WedHours !== undefined) {
                _pickupRequest.hasWednesdayHours = props.pickupData.WedHours !== '';
            }

            if (props.pickupData.ThuHours !== undefined) {
                _pickupRequest.hasThursdayHours = props.pickupData.ThuHours !== '';
            }

            if (props.pickupData.FriHours !== undefined) {
                _pickupRequest.hasFridayHours = props.pickupData.FriHours !== '';
            }

            if (props.pickupData.SatHours !== undefined) {
                _pickupRequest.hasSaturdayHours = props.pickupData.SatHours !== '';
            }

            if (props.pickupData.SunHours !== undefined) {
                _pickupRequest.hasSundayHours = props.pickupData.SunHours !== '';
            }

            if (_pickupRequest.hasMondayHours) {
                let start = props.pickupData.MonHours.split(' to ')[0];
                let end = props.pickupData.MonHours.split(' to ')[1];
                _pickupRequest.mondayHoursStart = dayjs().hour(parseInt(start.split(':')[0])).minute(parseInt(start.split(':')[1]));
                _pickupRequest.mondayHoursEnd = dayjs().hour(parseInt(end.split(':')[0])).minute(parseInt(end.split(':')[1]));
            }

            if (_pickupRequest.hasTuesdayHours) {
                let start = props.pickupData.TueHours.split(' to ')[0];
                let end = props.pickupData.TueHours.split(' to ')[1];
                _pickupRequest.tuesdayHoursStart = dayjs().hour(parseInt(start.split(':')[0])).minute(parseInt(start.split(':')[1]));
                _pickupRequest.tuesdayHoursEnd = dayjs().hour(parseInt(end.split(':')[0])).minute(parseInt(end.split(':')[1]));
            }

            if (_pickupRequest.hasWednesdayHours) {
                let start = props.pickupData.WedHours.split(' to ')[0];
                let end = props.pickupData.WedHours.split(' to ')[1];
                _pickupRequest.wednesdayHoursStart = dayjs().hour(parseInt(start.split(':')[0])).minute(parseInt(start.split(':')[1]));
                _pickupRequest.wednesdayHoursEnd = dayjs().hour(parseInt(end.split(':')[0])).minute(parseInt(end.split(':')[1]));
            }


            if (_pickupRequest.hasThursdayHours) {
                let start = props.pickupData.ThuHours.split(' to ')[0];
                let end = props.pickupData.ThuHours.split(' to ')[1];
                _pickupRequest.thursdayHoursStart = dayjs().hour(parseInt(start.split(':')[0])).minute(parseInt(start.split(':')[1]));
                _pickupRequest.thursdayHoursEnd = dayjs().hour(parseInt(end.split(':')[0])).minute(parseInt(end.split(':')[1]));
            }

            if (_pickupRequest.hasFridayHours) {
                let start = props.pickupData.FriHours.split(' to ')[0];
                let end = props.pickupData.FriHours.split(' to ')[1];
                _pickupRequest.fridayHoursStart = dayjs().hour(parseInt(start.split(':')[0])).minute(parseInt(start.split(':')[1]));
                _pickupRequest.fridayHoursEnd = dayjs().hour(parseInt(end.split(':')[0])).minute(parseInt(end.split(':')[1]));
            }

            if (_pickupRequest.hasSaturdayHours) {
                let start = props.pickupData.SatHours.split(' to ')[0];
                let end = props.pickupData.SatHours.split(' to ')[1];
                _pickupRequest.saturdayHoursStart = dayjs().hour(parseInt(start.split(':')[0])).minute(parseInt(start.split(':')[1]));
                _pickupRequest.saturdayHoursEnd = dayjs().hour(parseInt(end.split(':')[0])).minute(parseInt(end.split(':')[1]));
            }

            if (_pickupRequest.hasSundayHours) {
                let start = props.pickupData.SunHours.split(' to ')[0];
                let end = props.pickupData.SunHours.split(' to ')[1];
                _pickupRequest.sundayHoursStart = dayjs().hour(parseInt(start.split(':')[0])).minute(parseInt(start.split(':')[1]));
                _pickupRequest.sundayHoursEnd = dayjs().hour(parseInt(end.split(':')[0])).minute(parseInt(end.split(':')[1]));
            }
            //formattedPickup.Business_DoW_Hours.push(_pickupRequest.hasMondayHours ? [_pickupRequest.mondayHoursStart.format('HH:mm'), _pickupRequest.mondayHoursEnd.format('HH:mm')] : null);

        }
    }
    
    function buildWizard() {

        let panel = null;

        if (isLoading) {
            panel = buildLoadingPanel();
        }
        else if (activeStep === 'Select Date and Type') {
            if (props.pickupData !== null && props.pickupData.Client.ClientId != 0) {
                // initialized with a quick-tag
                setupQuickTagData();
            }
            panel = <AvailableDateAndCustomerType pickupData={props.pickupData} pickupRequest={_pickupRequest} onCancel={props.onCancel} onBack={props.onCancel} onNext={(date, type) => AvailableDateAndCustomerType_OnAccepted(date, type)} />
        }
        else if (activeStep === 'Acknowledge Contactless Pickup') {
            panel = <ContactlessPickup pickupRequest={_pickupRequest} onBack={() => stepBack()} onNext={(isContactless) => ContactlessPickup_OnAccepted(isContactless)} />
        }
        else if (activeStep === 'Count or Estimator') {
            panel = <CountOrEstimator pickupRequest={_pickupRequest} onBack={() => stepBack()} onNext={(quantifier) => CountOrEstimator_OnAccepted(quantifier)} />
        }
        else if (activeStep === 'Business Hours') {
            panel = <BusinessHours pickupRequest={_pickupRequest} onBack={() => stepBack()} onNext={BusinessHours_OnAccepted} />
        }
        else if (activeStep === 'Exact Count') {
            panel = <QuantityPanel pickupRequest={_pickupRequest} calculatePayment={(quantity) => calculatePayment(quantity)} orderMinimumQuantity={() => orderMinimumQuantity()} orderMaximumQuantity={() => orderMaximumQuantity()} onBack={() => stepBack()} onNext={ExactCount_OnAccepted} />
        }
        else if (activeStep === 'Estimator') {
            panel = <EstimateSummary pickupRequest={_pickupRequest} pickupData={props.pickupData} calculatePayment={(quantity) => calculatePayment(quantity)} orderMinimumQuantity={() => orderMinimumQuantity()} orderMaximumQuantity={() => orderMaximumQuantity()} onBack={() => stepBack()} onNext={Estimator_OnAccepted} />
        }
        else if (activeStep === 'Payment Options') {
            panel = <PaymentOptions pickupRequest={_pickupRequest} pickupData={props.pickupData} onNext={PaymentOption_OnAccepted} onBack={() => stepBack()} />
        }
        else if (activeStep === 'Customer Information') {
            panel = <CustomerInformation pickupRequest={_pickupRequest} pickupData={props.pickupData} onNext={CustomerInformation_OnAccepted} onBack={() => stepBack()} />
        }
        else if (activeStep === 'Special Instructions') {
            panel = <SpecialInstructions pickupRequest={_pickupRequest} onNext={SpecialInstructions_OnAccepted } onBack = { () => stepBack() } />
        }
        else if (activeStep === 'Store Selection') {
            panel = <StoreSelection pickupRequest={_pickupRequest} onNext={StoreSelection_OnAccepted} onBack={() => stepBack()} />
        }
        else if (activeStep === 'Summary') {
            panel = <Summary pickupRequest={_pickupRequest} pickupData={props.pickupData} calculatePayment={(quantity) => calculatePayment(quantity)} onNext={Summary_OnAccepted} onBack={() => stepBack()} />
        }
        else if (activeStep === 'Confirmation') {
            panel = <Confirmation pickupRequest={_pickupRequest}  />
        }
        else if (activeStep === 'Existing Pickup') {
            panel = <ExistingPickup pickupRequest={existingPickup} />
        }
        
       
        return <div style={{padding:'10px'} }>

            <Box display="flex"
                justifyContent="flex-end"
                alignItems="center"
                noValidate
                marginTop="5px"
            >
                <Button onClick={closePickupWizard}>{(activeStep === 'Confirmation' || activeStep === 'Existing Pickup') ? 'Close' : 'Cancel'} <ClearIcon /></Button>
            </Box>

            <div style={{ display: 'flex', justifyContent:'center' }}>
                <LinearProgress variant="determinate" value={(stepNumber / numberOfSteps * 100)} sx={{ maxWidth: 400, flexGrow: 1 }} />
            </div>
           
                    {panel}
            <ScrollMore />
            
        </div>;
    }

   
}

export default PickupWizard;